import * as React from "react";
import { WizardHotelPWAFlexComponent } from "../typings";
import { UitkCheckbox } from "uitk-react-switch";
import { locKeys } from "./l10n";
import { useLocalization } from "@shared-ui/localization-context";

export const MultiplePlaces = ({
  flexComponent,
  changeFormProperties,
  isMultiplePlacesNeeded,
  disablePackageOptions
}: {
  flexComponent: WizardHotelPWAFlexComponent;
  isMultiplePlacesNeeded: boolean;
  changeFormProperties: (event: React.ChangeEvent<HTMLFormElement>) => void;
  disablePackageOptions?: boolean;
}) => {
  if (!flexComponent.model.enableMultiplePlaces) {
    return null;
  }
  const { formatText } = useLocalization();

  return (
    <div className="packageCheckbox all-r-padding-three">
      <UitkCheckbox
        id="multiProp"
        label={formatText(locKeys.needMultiplePlaces)}
        checked={isMultiplePlacesNeeded}
        onChange={changeFormProperties}
        disabled={disablePackageOptions}
      />
    </div>
  );
};
